import { render } from "./NotificationBanner.vue?vue&type=template&id=5caecf9c&scoped=true"
import script from "./NotificationBanner.vue?vue&type=script&lang=js"
export * from "./NotificationBanner.vue?vue&type=script&lang=js"

import "./NotificationBanner.vue?vue&type=style&index=0&id=5caecf9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caecf9c"]])

export default __exports__